<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        
        <div class="illustrate">
            <div class="title">{{ isEnglish ?illustrate.titleen:illustrate.title}}</div>
            <div class="contentphone">{{ isEnglish ?illustrate.contentphoneen: illustrate.contentphone }}</div>
            <div class="contentemail">{{ isEnglish ?illustrate.contentemailen: illustrate.contentemail }}</div>
            <div style="margin-top: 7vh; width: 17vw; margin-right: 43vw; border-bottom: 1px solid gray;"></div>
        </div>
   
        <div class="fomeillustrate">
            <div class="title">{{ isEnglish ?fomeillustratecontent.titleen:fomeillustratecontent.title}}</div>
            <div class="form-container">
                <form class="custom-form" @submit.prevent="handleSubmit">
                       <!-- 姓名 -->
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.nameen:fomeillustratecontent.name}}</label>
                        <input type="text" id="name" v-model="fomeillustrate.name" :placeholder="isEnglish ?fomeillustratecontent.alertnameen:fomeillustratecontent.alertname">
                    </div>
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.companyen:fomeillustratecontent.company}}</label>
                        <input type="text" id="company" v-model="fomeillustrate.company" :placeholder="isEnglish ?fomeillustratecontent.alertcompanyen:fomeillustratecontent.alertcompany">
                    </div>
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.phoneen:fomeillustratecontent.phone}}</label>
                        <input type="text" id="phone" v-model="fomeillustrate.phone" :placeholder="isEnglish ?fomeillustratecontent.alertphoneen:fomeillustratecontent.alertphone">
                    </div>
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.emailen:fomeillustratecontent.email}}</label>
                        <input type="text" id="email" v-model="fomeillustrate.email" :placeholder="isEnglish ?fomeillustratecontent.alertemailen:fomeillustratecontent.alertemail">
                    </div>
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.addressen:fomeillustratecontent.address}}</label>
                        <input type="text" id="address" v-model="fomeillustrate.address" :placeholder="isEnglish ?fomeillustratecontent.alertaddressen:fomeillustratecontent.alertaddress">
                    </div>
                    <div class="form-group">
                        <label for="name">{{ isEnglish ?fomeillustratecontent.messageen:fomeillustratecontent.message}}</label>
                        <textarea  id="message" v-model="fomeillustrate.message":placeholder="isEnglish ?fomeillustratecontent.alertmessageen:fomeillustratecontent.alertmessage"></textarea>
                    </div>

                            <!-- 提交按钮 -->
                    <div class="form-group">
                        <button type="submit" :disabled="isSubmitting" class="submit-btn">{{ isEnglish ?'submit':'点击发送'}}</button>
                    </div>
                </form>
            </div>
        </div>

                 
       
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下


    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
              
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
           
        },
        data() {
            return { 
                isSubmitting: false, // 用于控制是否正在提交
                illustrate:{
                    title:'联系我们',
                    contentphone:'服务热线:   86-20-3939 0239',
                    contentemail:'邮箱:    coop@puki.vip',
                    titleen:'暂无',
                    contentphoneen:'暂无',
                    contentemailen:'暂无',

                },
                fomeillustratecontent:{
                    title:'商业合作',
                    name: '姓名',
                    company: '公司名称',
                    phone: '联系电话',
                    email: '邮箱',
                    address: '地址',
                    message: '留言内容',

                    titleen:'Commercial Cooperation',
                    nameen: 'name',
                    companyen: 'company',
                    phoneen: 'phone',
                    emailen: 'email',
                    addressen: 'address',
                    messageen: 'message',

                    alertname: '请输入您的姓名',
                    alertcompany: '请输入您的公司名称',
                    alertphone: '请输入您的联系电话',
                    alertemail: '请输入您的邮箱',
                    alertaddress: '请输入您的地址',
                    alertmessage: '请输入您的留言内容',

                    alerttitleen:'Please enter your ttitle',
                    alertnameen: 'Please enter your name',
                    alertcompanyen: 'Please enter your company name',
                    alertphoneen: 'Please enter your phone number',
                    alertemailen: 'Please enter your email address',
                    alertaddressen: 'Please enter your address',
                    alertmessageen: 'Please enter your message content'
                },
                fomeillustrate:{
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    address: '',
                    message: ''
                },
                    

                imageUrlone: require('../../assets/Partnersbanner.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                isScrolled: false,
        
            };
        },

        mounted() {
            // 初次加载时立即调用一次 fetchData，确保使用当前的 isEnglish
            this.fetchData();

            this.initObserver(); // 初始化观察器
             window.addEventListener('wheel', this.initObserver, { passive: false });
            

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {
 /**
             * 获取页面数据
             */
            async fetchData() {
                            try {
                            // 发起API请求
                            const response = await axios.get(`${apiUrls.baseUrl}/website/api/partners`);
                           
                            
                            if (response.data && response.data.length > 0) {
                                const data = response.data[0]; // 假设只需要第一个对象的数据
                                this.imageUrlone = `${apiUrls.devApi}${data.imageUrlone}`;
                                  // 赋值给 illustrate
                                this.illustrate = {
                                title: data.title,
                                contentphone: data.contentphone,
                                contentemail: data.contentemail,
                                titleen: data.titleen,
                                contentphoneen: data.contentphoneen,
                                contentemailen: data.contentemailen
                                };
                              
                            }
                            } catch (error) {
                            console.error('获取数据失败:', error);
                            }
                                },

                                /**
                 * 验证表单输入
                 */
                validateForm() {
                    const { name, company, phone, email, address, message } = this.fomeillustrate;

                    // 校验每个字段是否为空
                    if (!name || !phone || !email) {
                        return false;
                    }

                    // 根据需要添加其他字段的校验逻辑（例如正则验证邮箱格式）
                    return true;
                },
            /**
             * 提交表单
             */
            handleSubmit() {
                if (this.isSubmitting) {
                    // 如果正在提交，防止重复提交
                    return;
                }
                
                                // 验证表单输入
                    if (!this.validateForm()) {
                        this.$message.error('请填写完整的表单信息！');
                        return;
                    } 
                     // 设置提交状态为正在提交
                  this.isSubmitting = true;

                  console.log('表单数据准备提交:', this.fomeillustrate);
               
                  // 使用 axios 发起 POST 请求将数据提交到后端
                    axios.post(`${apiUrls.baseUrl}/website/addpartnersuer`, this.fomeillustrate)
                        .then(response => {
                            this.$message({
                                message: response.data || '已提交！',
                                type: 'success',
                                duration: 2000
                            });

                            // 提交成功后清空表单
                            this.fomeillustrate = {
                                name: '',
                                company: '',
                                phone: '',
                                email: '',
                                address: '',
                                message: ''
                            };

                             // 提交成功后清空表单
                              this.resetForm();

                            // 3秒后恢复提交按钮可点击状态   
                            setTimeout(() => {
                                this.isSubmitting = false;
                            }, 3000);
                        })
                        .catch(error => {
                            const errorMessage = error.response.data.message;
                            this.$message.error(errorMessage);
                            this.isSubmitting = false;
                        });                
            },
          

            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>

   /* 按钮样式 */
   .submit-btn {
            width: 6vw;
            padding: 1.5vh;
            background-color: #333;
            color: white;
            font-size: 0.8rem;
            font-weight: bold;
            border: none;
            border-radius: 3px;
            cursor: pointer;
            transition: background-color 0.3s;
            margin-left: 12.2vw;
            
        }
        .submit-btn:hover {
            background-color: #555;
        }

.fomeillustrate{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    margin-top: -3vh;
    /* height: 40vh; */
    margin-bottom: 18vh;
   
}
.fomeillustrate .title{
    width: 60vw;
        font-weight: bold;
        font-size: 1.5rem;
     margin-bottom: 5vh;
}

  /* 表单容器样式 */
  .form-container {
            display: flex;
            justify-content: center;
            align-items: center;
            /* min-height: 100vh; */
            background-color: white;
        
        }

  .form-container .custom-form{
          width: 60vw;
          /* background-color: white; */
          border-radius: 5px;
          /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
        }
        .form-container .custom-form .form-group {
            margin-bottom: 6vh;
            display: flex;
            align-items: center;
            gap: 7vw;
            
        }
        .form-container .custom-form .form-group label {
            width: 5vw; /* 标签宽度，保持对齐 */
            font-size: 1rem;
            color: #333;
            text-align: left;
            
        }
        .form-container .custom-form .form-group input, textarea {
            flex: 1;
            padding: 1vw;
            border: 1px solid #ddd;
            /* border-radius: 3px; */
            background-color: #f5f5f5;
            font-size: 14px;
            color: #333;
            outline: none;
            transition: border-color 0.3s;

        }

        textarea {
            resize: none; /* 禁止调整大小 */
            height: 10vh;
        }


.illustrate{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    margin-top: 5vh;
    height: 45vh;
   
}
.illustrate .title{
        width: 60vw;
        font-weight: bold;
        font-size: 1.5rem;
        margin-bottom: 3vh;
        
      
}
.illustrate .contentphone{
    width: 60vw;
   
    font-size:1rem;
    line-height: 2;
    color: gray;
    white-space: pre;
}
.illustrate .contentemail{
        width: 60vw;
        font-size:1rem;
        line-height: 2;
        color: gray;
        white-space: pre;
      
}


/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
